export default {
  AppFooter__BOTTOM_NAV_ARIA: "bottom navigation",
};
